module.exports = {"href":"/corgi/pageapps/prepurchase/_next/public/sprite-7.28.0-f3d742a11.svg#instagram-flat","viewBox":"0 0 512.001 512.001"}